export const safeDecodeUriComponent = (s: string) => {
    try {
        return decodeURIComponent(s)
    } catch (_e) {
        return s
    }
}
